import React from "react";
import { Label } from "@fluentui/react";

export interface LabelWithDotsAndLineProps {
  text: string;
}

export default class LabelWithDotsAndLine extends React.Component<LabelWithDotsAndLineProps> {
  render() {
    const { text } = this.props;
    return (
      <>
        <Label style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}>{text}</Label>
        <div
          style={{
            borderBottom: `0.1rem solid var(--color-blue)`,
          }}
        />
      </>
    );
  }
}
